import React from "react";
import { Button } from "../../../../ui";
import "./ui-pending.scss";

interface PagerProps {
  /** e.g. "Page 2 of 5 · 140 rows" */
  summary: React.ReactNode;
  canPrev: boolean;
  canNext: boolean;
  onPrev: () => void;
  onNext: () => void;
  className?: string;
}

/** Prev / Next pager for server-paged lists (design-system candidate). */
export const Pager: React.FC<PagerProps> = ({ summary, canPrev, canNext, onPrev, onNext, className }) => (
  <nav className={["dops-pager", className].filter(Boolean).join(" ")} aria-label="Pagination">
    <span className="dops-pager__summary">{summary}</span>
    <div className="dops-pager__buttons">
      <Button size="sm" variant="secondary" disabled={!canPrev} onClick={onPrev}>
        Prev
      </Button>
      <Button size="sm" variant="secondary" disabled={!canNext} onClick={onNext}>
        Next
      </Button>
    </div>
  </nav>
);

export default Pager;
